import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import type { TypedComponentRendering } from '@core/jss-models';
import type { FullCalculateFormValues } from '@innogy/become-a-customer/shared';
import {
  CalculateComponentContent,
  type CalculateComponentRendering,
} from '@innogy/become-a-customer/shared/interfaces';
import { CommonUiFormsModule } from '@innogy/common-ui/forms';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import {
  AutocompleteDirective,
  IsInvalidPipe,
  IsValidPipe,
  stringNumberConverterForLocale,
} from '@innogy/utils-deprecated';
import { FormGroupControls, FormGroupState, NgrxFormsModule } from 'ngrx-forms';
import {
  CrntFormControl,
  CrntFormControlLabel,
  CrntIcon,
  CrntTextInput,
} from '@essent/current-web-angular';

@Component({
  selector: 'wl-calculate-form-usage',
  templateUrl: './calculate-form-usage.component.html',
  styleUrls: [
    './calculate-form-usage.component.essent.scss',
    './calculate-form-usage.component.ed.scss',
  ],
  standalone: true,
  imports: [
    CommonModule,
    AutomationIdDirective,
    CommonUiFormsModule,
    AutomationIdDirective,
    AutocompleteDirective,
    IsInvalidPipe,
    IsValidPipe,
    NgrxFormsModule,
    CrntFormControl,
    CrntFormControlLabel,
    CrntIcon,
    CrntTextInput,
  ],
})
export class CalculateFormUsageComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) content!: CalculateComponentContent;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: TypedComponentRendering<CalculateComponentRendering>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() controls?: FormGroupControls<FullCalculateFormValues>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formState?: FormGroupState<FullCalculateFormValues>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() shouldHideGasField = false;

  @Output() public calculateOpenModal = new EventEmitter<boolean>();

  get shouldShowGasField(): boolean {
    return !this.shouldHideGasField && !this.content.gasHidden;
  }

  public readonly _stringNumberConverter =
    stringNumberConverterForLocale('nl-NL');
}
